module.exports = __webpack_public_path__ + "41cccad42660323fc1e5dee5ec8d0c2c.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/burger.jpg
 ** module id = 478
 ** module chunks = 0
 **/